import { authClient, API } from "../index";

/**
 * Lista decisiones hub (prefiltro / runner sin orden).
 * @param {Record<string, string|number|undefined>} params
 */
export const getRunnerSymbolDecisions = (params = {}) => {
  return authClient().get(`${API}/exchange/operation/runner-symbol-decisions`, {
    params,
  });
};

export const getRunnerSymbolDecisionById = (id) => {
  return authClient().get(
    `${API}/exchange/operation/runner-symbol-decisions/${encodeURIComponent(id)}`,
  );
};
